import { green, red } from "@material-ui/core/colors";

export function getCategoryColor(color: string) { // TODO: this is a different color from the theme; maybe we need to align with the theme?
  if (color === 'red') return red[300];
  if (color === 'green') return green[400];
	if (color === 'nodata') return "#674A1E";
  return color;
}